module.exports = __webpack_public_path__ + "v1.0.0/img/searh-close.c6b4cf2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/bases/searh-close.svg
// module id = JU8Q
// module chunks = 9